<!--SystemIntroduce:系统介绍 2021/03/29 10:09:01 Sunanguang-->

<template>
   <div class="its-system-introduce">
     <div class="its-system-main-title">十大应用系统  为智慧教学护航</div>
     <div class="its-system-list">
       <div v-for="(system, i) in systems" :key="'system-' + i" class="its-system-item" :class="['its-system-item-' + system.id, system.hover?'its-zIndex':'']">
         <div class="its-six-angle" :class="{'blue': [3,5,6,10].indexOf(system.id) >= 0}"></div>
         <div class="its-system-info" @mouseenter="system.hover=true" @mouseleave="system.hover=false">
           <img :src="getSrc(system.id)">
            <p class="its-system-title">{{system.name}}</p>
         </div>
         <div v-if="system.hover" class="its-six-bg" :class="{'its-system-bg-left': system.id >= 6}">
           <p class="its-info-title">{{system.name}}</p>
           <p class="its-info-desc" v-html="system.desc"></p>
         </div>
       </div>
     </div>
   </div>
</template>
<script>
export default {
  name: 'SystemIntroduce',
  data () {
    return {
      systems: [
        {
          id: 1,
          hover: false,
          name: '数字资源应用系统',
          desc: '优质数字资源库实时更新，智能匹配<br>全国精选试题库精品专题，快速组卷'
        },
        {
          id: 2,
          name: '在线备课系统',
          hover: false,
          desc: '在线编辑，实时保存，轻松备好课<br>集体备课，成果共享，沉淀特色资源'
        },
        {
          id: 3,
          name: '智能授课系统',
          hover: false,
          desc: '多样互动应用，实现趣味教学<br>特色学科工具，助力优质课堂<br>AI 智能测评，反馈即时呈现'
        },
        
        {
          id: 4,
          name: '预习训练系统',
          hover: false,
          desc: '在线灵活布置，任务一键收发<br>数据实时反馈，明确教学重难点'
        },
        {
          id: 5,
          name: '英语智能测评系统',
          hover: false,
          desc: '口语听力精准测评<br>个性化语音纠错<br>作文智能批改<br>轻松应对口语考试'
        },
        {
          id: 6,
          name: '学情分析系统',
          hover: false,
          desc: '教学数据，实时查看<br>教学管理，有据可依'
        },
        {
          id: 7,
          name: '家校互通互联系统',
          hover: false,
          desc: '实时掌握孩子学习动态及在校表现<br>家校共育高效沟通，陪伴孩子快乐成长'
        },
        {
          id: 8,
          name: '大数据智慧管理系统',
          hover: false,
          desc: '● 学校管理者<br>多角色多维度教学数据采集<br>教学管理有据可依，提高教学质量<br>● 教育管理部门<br>快速统筹区域学情，剖析教学问题<br>助力精准管理，科学决策'
        },
        {
          id: 9,
          name: '区域信息化管理平台',
          hover: false,
          desc: '开放式平台，汇聚特色教学应用<br>区域资源共建共享 ，资源分发一触即达<br>应用灵活便捷，效果监测深度追踪'
        },
        {
          id: 10,
          name: '自主学习提升系统',
          hover: false,
          desc: '专项突破、同步巩固，分层指导<br>个性化学习方案，帮助学生减负增效'
        },
      ]
    }
  },
  methods: {
    getSrc: function (id) {
      return require('@/assets/images/home/system_' + id + '.png')
    }
  }
}
</script>

<style scoped>
.its-system-introduce {
  width: 100%;
  height: 903px;
  background-color: white;
  padding-top: 94px;
  background: url(../../../../assets/images/home/system_bg.png) no-repeat !important;
  background-size: 100%;
}

.its-system-main-title {
  font-size: 36px;
  color: black;
  text-align: center;
}

.its-system-list {
  width: 1235px;
  margin: 89px auto 0 auto;
}

.its-six-angle {
  position: absolute;
  width: 124.4px;
  height: 215.4px;
  background-color: #7096F4;
  text-align: center;
  z-index: 1;
}

.its-six-angle:before {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    right: 124.4px;
    border-width: 107px 62px;
    border-style: solid;
    border-color: transparent #7096F4 transparent transparent;
}

.its-six-angle:after {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    left: 124.4px;
    border-width: 107px 62px;
    border-style: solid;
    border-color: transparent transparent transparent #7096F4;
    top:0;
}

.its-six-angle img {
  margin-top: 67px;
}

.its-six-angle.blue {
  background-color: #477EF5;
}

.its-six-angle.blue::before {
  border-color: transparent #477EF5 transparent transparent;
}

.its-six-angle.blue::after {
  border-color: transparent transparent transparent #477EF5;
}

.its-six-bg {
  width: 402px;
  height: 349px;
  background-color: white;
  background: url(../../../../assets/images/home/six-angle.png) no-repeat !important;
  background-size: 100%;
  position: absolute;
  z-index: 3;
  left: 180px;
  top: -67px;
  text-align: center;
}

.its-six-bg .its-info-title {
  font-size: 24px;
  color: black;
  margin-top: 78px;
}

.its-six-bg .its-info-desc {
  color: #333333;
  font-size: 14px;
  line-height: 2;
  text-align: left;
  width: 240px;
  margin: 10px auto 0 auto;
  text-align: center;
}

.its-system-bg-left {
  left: -459px;
}

.its-system-item {
  position: absolute;
  z-index: 1;
  width: 248px;
}

.its-inner-angle {
  position: absolute;
  width: 388px;
  height: 335px;
}

.its-system-title {
  margin-top: 36px;
  font-size: 18px;
  color: white;
}

.its-system-info {
  position: relative;
  z-index: 2;
  text-align: center;
  width: 248px;
  margin-left: -62px;
  padding-top: 67px;
  height: 215.4px;
  cursor: pointer;
}

.its-system-info:hover .its-six-bg {
  display: block;
}

.its-system-item-2 {
  margin-left: 187px;
  margin-top: 108px;
}

.its-system-item-3 {
  margin-left: 374px;
  margin-top: 0;
}

.its-system-item-4 {
  margin-left: 374px;
  margin-top: 216px;
}

.its-system-item-5 {
  margin-left: 561px;
  margin-top: 108px;
}

.its-system-item-6 {
  margin-left: 748px;
  margin-top: 0
}

.its-system-item-7 {
  margin-left: 748px;
  margin-top: 216px;
}

.its-system-item-8 {
  margin-left: 935px;
  margin-top: 108px;
}

.its-system-item-9 {
  margin-left: 1122px;
  margin-top: 0
}

.its-system-item-10 {
  margin-left: 561px;
  margin-top: 324px;
}

.its-zIndex {
  z-index: 3;
}

.ie-browser .its-system-item-4,
.ie-browser .its-system-item-7 {
  margin-top: 217px;
}

.its-system-item-1 .its-info-desc {
  text-align: center;
  margin-top: 40px;
}

.its-system-item-2 .its-info-desc {
  margin-top: 40px;
}

.its-system-item-3 .its-info-desc {
  margin-top: 26px;
}

.its-system-item-4 .its-info-desc {
  margin-top: 40px;
}

.its-system-item-5 .its-info-desc {
  margin-top: 14px;
}

.its-system-item-6 .its-info-desc {
  margin-top: 40px;
  text-align: center;
}

.its-system-item-7 .its-info-desc {
  margin-top: 40px;
}

.its-system-item-8 .its-info-desc {
  margin-top: 10px;
}

.its-system-item-9 .its-info-desc {
  margin-top: 26px;
  width: 245px;
}

.its-system-item-10 .its-info-desc {
  margin-top: 40px;
}

</style>